/**
 * WHICH ALARM TOASTS A VIEWER SEES, AND WHAT THEY CALL THE DEVICE (2026-10-21, the browser pass).
 *
 * A toast names its SITE: a viewer of JAZZMSC5 got four "Critical Raised · Mains Failure" toasts
 * from a demo site with nothing saying so, which would alarm anyone watching the real site. And a
 * simulated site's toasts reach only a viewer looking at demo sites: one whose header has that site
 * selected, or whose header has the demo organisation selected with a demo site in view. Never over
 * a real site — a generated grid failure must not interrupt someone watching a real one.
 *
 * The device is called what the rest of the console calls it: a -48 V system is "DC system 1"
 * (`dcSystemNames`), never its wire name. Pure.
 */
import { dcSystemNames } from '@/modules/overview/data-centre';

export interface ToastSite {
  id: string;
  name: string;
  organisationId: string;
  simulated?: boolean;
}

export function toastShown(
  site: ToastSite | undefined,
  selected: { id: string; simulated?: boolean } | null,
  selectedOrgId: string | null,
): boolean {
  if (!site || site.simulated !== true) return true;
  if (selected?.simulated !== true) return false;
  return selected.id === site.id || selectedOrgId === site.organisationId;
}

export function operatorDeviceName(
  wireName: string,
  devices: ReadonlyArray<{ id: number; deviceName: string; label: string | null; roleKey: string | null }>,
): string {
  const named = (d: (typeof devices)[number]) => d.label ?? d.deviceName;
  const me = devices.find((d) => named(d) === wireName || d.deviceName === wireName);
  if (!me || me.roleKey !== 'rectifier') return wireName;
  const systems = devices.filter((d) => d.roleKey === 'rectifier').map((d) => ({ id: d.id, name: named(d) }));
  return dcSystemNames(systems).get(me.id) ?? wireName;
}
